import { Lang, Localized, pick } from './types'

interface RawPackage {
  name: Localized
  desc: Localized
  priceNote?: Localized
  price: Localized
}

interface RawAddOn {
  name: Localized
  price: Localized
}

export interface BridalPackage {
  name: string
  desc: string
  priceNote?: string
  price: string
}

export interface BridalAddOn {
  name: string
  price: string
}

export interface BridalCopy {
  rule: string
  eyebrow: string
  title: string
  subtitle: string
  imageAltMakeup: string
  imageAltUpdo: string
  packagesTitle: string
  packages: BridalPackage[]
  addOnsTitle: string
  addOnsSubtitle: string
  addOns: BridalAddOn[]
  note: string
  ctaPrimary: string
  ctaSecondary: string
  whatsappMessage: string
}

const rule: Localized = {
  es: 'Novias & Eventos',
  en: 'Brides & Events',
}

const eyebrow: Localized = {
  es: 'El día más importante de tu vida',
  en: 'The most important day of your life',
}

const title: Localized = {
  es: 'Servicios para Novias & Eventos Especiales',
  en: 'Bridal & Special Event Services',
}

const subtitle: Localized = {
  es: 'Cada detalle, perfectamente pensado para el día más importante de tu vida.',
  en: 'Every detail, perfectly considered for the most important day of your life.',
}

const imageAltMakeup: Localized = {
  es: 'Novia recibiendo maquillaje profesional frente al espejo del estudio',
  en: 'Bride receiving professional makeup in front of the studio mirror',
}

const imageAltUpdo: Localized = {
  es: 'Recogido de novia con detalles de perlas',
  en: 'Bridal updo finished with pearl details',
}

const packagesTitle: Localized = {
  es: 'Nuestros Paquetes',
  en: 'Our Packages',
}

const addOnsTitle: Localized = {
  es: 'Personaliza Tu Look',
  en: 'Personalize Your Look',
}

const addOnsSubtitle: Localized = {
  es: 'Complementa tu experiencia con nuestros servicios à la carte.',
  en: 'Complete your experience with our à la carte services.',
}

const note: Localized = {
  es: 'Los precios son estimados y pueden variar según la longitud, el grosor y la complejidad del estilo solicitado. Se requiere un depósito no reembolsable para confirmar tu reserva. Contáctanos para una cotización personalizada.',
  en: 'Prices are estimates and may vary depending on hair length, thickness and the complexity of the requested style. A non-refundable deposit is required to confirm your booking. Contact us for a personalized quote.',
}

const ctaPrimary: Localized = {
  es: 'Reserva Tu Consulta de Novia',
  en: 'Book Your Bridal Consultation',
}

const ctaSecondary: Localized = {
  es: 'Escríbenos por WhatsApp para una Cotización',
  en: 'Message Us on WhatsApp for a Quote',
}

const whatsappMessage: Localized = {
  es: 'Hola Ginger, quiero una cotización para servicios de novia.',
  en: 'Hi Ginger, I would like a quote for bridal services.',
}

const rawPackages: RawPackage[] = [
  {
    name: { es: 'Prueba de Novia (Bridal Trial)', en: 'Bridal Trial' },
    desc: {
      es: 'Prueba completa de maquillaje y peinado. Se realiza semanas antes del día B para garantizar el look perfecto.',
      en: 'Full makeup and hairstyling trial. Done weeks before the big day to guarantee the perfect look.',
    },
    priceNote: { es: 'Desde', en: 'From' },
    price: { es: '$150 – $350', en: '$150 – $350' },
  },
  {
    name: {
      es: 'Día de la Boda (Glam Completo)',
      en: 'Wedding Day (Full Glam)',
    },
    desc: {
      es: 'Maquillaje y peinado completo para la novia el día del evento.',
      en: 'Complete makeup and hairstyling for the bride on the day of the event.',
    },
    priceNote: { es: 'Desde', en: 'From' },
    price: { es: '$300 – $600', en: '$300 – $600' },
  },
  {
    name: {
      es: 'Día de la Boda (Servicio Individual)',
      en: 'Wedding Day (Single Service)',
    },
    desc: {
      es: 'Solo maquillaje O solo peinado para la novia.',
      en: 'Makeup only OR hairstyling only for the bride.',
    },
    priceNote: { es: 'Desde', en: 'From' },
    price: { es: '$250 – $350', en: '$250 – $350' },
  },
  {
    name: {
      es: 'Dama de Honor / Invitada Especial',
      en: 'Bridesmaid / Special Guest',
    },
    desc: {
      es: 'Maquillaje y peinado para damas de honor e invitadas del evento.',
      en: 'Makeup and hairstyling for bridesmaids and event guests.',
    },
    priceNote: { es: 'Por persona', en: 'Per person' },
    price: { es: '$180 – $250', en: '$180 – $250' },
  },
]

const rawAddOns: RawAddOn[] = [
  {
    name: {
      es: 'Colocación de Extensiones de Clip + Peinado',
      en: 'Clip-In Extension Placement + Styling',
    },
    price: { es: '+ $65', en: '+ $65' },
  },
  {
    name: { es: 'Secado / Brushing', en: 'Blowout / Brushing' },
    price: { es: '$30 – $50', en: '$30 – $50' },
  },
  {
    name: {
      es: 'Recargo por Cabello Muy Largo o Abundante',
      en: 'Extra Long or Thick Hair Surcharge',
    },
    price: { es: '+ $50', en: '+ $50' },
  },
  {
    name: { es: 'Recargo por Ondas Glamurosas', en: 'Glam Waves Surcharge' },
    price: { es: '+ $50', en: '+ $50' },
  },
  {
    name: {
      es: 'Aplicación de Pestañas Postizas',
      en: 'False Lash Application',
    },
    price: { es: 'Incluido o + $25 – $50', en: 'Included or + $25 – $50' },
  },
  {
    name: { es: 'Base con Aerógrafo', en: 'Airbrush Foundation' },
    price: { es: 'Incluido o + $25 – $50', en: 'Included or + $25 – $50' },
  },
  {
    name: {
      es: 'Servicio de Permanencia para Retoques (Novia)',
      en: 'On-Site Touch-Up Service (Bride)',
    },
    price: { es: '$100 / hora', en: '$100 / hour' },
  },
]

export function getBridalCopy(lang: Lang): BridalCopy {
  return {
    rule: pick(rule, lang),
    eyebrow: pick(eyebrow, lang),
    title: pick(title, lang),
    subtitle: pick(subtitle, lang),
    imageAltMakeup: pick(imageAltMakeup, lang),
    imageAltUpdo: pick(imageAltUpdo, lang),
    packagesTitle: pick(packagesTitle, lang),
    packages: rawPackages.map(item => ({
      name: pick(item.name, lang),
      desc: pick(item.desc, lang),
      priceNote: item.priceNote ? pick(item.priceNote, lang) : undefined,
      price: pick(item.price, lang),
    })),
    addOnsTitle: pick(addOnsTitle, lang),
    addOnsSubtitle: pick(addOnsSubtitle, lang),
    addOns: rawAddOns.map(item => ({
      name: pick(item.name, lang),
      price: pick(item.price, lang),
    })),
    note: pick(note, lang),
    ctaPrimary: pick(ctaPrimary, lang),
    ctaSecondary: pick(ctaSecondary, lang),
    whatsappMessage: pick(whatsappMessage, lang),
  }
}
